import React from 'react';
import AddSchemeAccount from '../../../components/Multi/ChildSchemeAccount/AddSchemeAccount';

const AddScheneAccountPage = () => {
  return (
    <div>
      <AddSchemeAccount />
    </div>
  )
}

export default AddScheneAccountPage
